import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webapp/cinehub/webapp/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webapp/cinehub/webapp/src/app/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/webapp/cinehub/webapp/src/styles/styles.css");
;
import(/* webpackMode: "eager" */ "/home/webapp/cinehub/webapp/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/home/webapp/cinehub/webapp/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-roboto\",\"weight\":[\"400\",\"700\"]}],\"variableName\":\"roboto\"}");
